import { defaultTo } from 'lodash';
import { IModel, ModelRecord } from '.';

export interface IBrandModel extends IModel {
  brandId: number;
  name: string;
  sourceSystemKey: string | undefined;
  sourceSystemId: number;
}

export interface IBrandModelUIFields {
  legalBackerHTML: string | undefined; //UI Only field
}

export class BrandModel
  implements ModelRecord<IBrandModel & IBrandModelUIFields>
{
  rowVersion: string;
  brandId: number;
  name: string;
  sourceSystemKey: string | undefined;
  sourceSystemId: number;
  legalBackerHTML: string | undefined; //UI Only field

  constructor(init?: Partial<IBrandModel & IBrandModelUIFields>) {
    this.rowVersion = defaultTo(init?.rowVersion, '');
    this.brandId = defaultTo(init?.brandId, 0);
    this.name = defaultTo(init?.name, '');
    this.sourceSystemKey = defaultTo(init?.sourceSystemKey, '');
    this.sourceSystemId = defaultTo(init?.sourceSystemId, 0);
    this.legalBackerHTML = defaultTo(init?.legalBackerHTML, undefined);
  }
}
